import { IPrimaryIncome } from '@/types'
import { capitalizeWords, formatDate } from '@/utils/common'

export const formatEnum = (value?: string | null) =>
  value && value !== 'UNSPECIFIED' ? capitalizeWords(value.toLowerCase().replace(/_/g, ' ')) : ''

// Recurring income amounts are stored as dollars (DECIMAL(10, 2)); manual pay cycle amounts are
// cents and are divided by 100 before they get here.
export const formatDollars = (value?: number | null) =>
  typeof value === 'number' && !Number.isNaN(value)
    ? value.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' })
    : ''

export const formatDay = (value?: string | null) => (value ? formatDate(value, false) : '')

const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

// UserPrimaryIncome stores the weekday as a number, unlike UserRecurringIncome's name.
export const primaryPayDay = (income: Pick<IPrimaryIncome, 'payDayOfWeek' | 'payDayOfMonth'>) => {
  if (typeof income.payDayOfWeek === 'number') return WEEKDAYS[income.payDayOfWeek] ?? ''
  if (typeof income.payDayOfMonth === 'number') return `Day ${income.payDayOfMonth}`
  return ''
}
